import React, { useEffect, useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import { useSnackbar } from "notistack";
import Fab from "@material-ui/core/Fab";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import Table from "../../Table";
import { useTranslation } from "react-multi-lang";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { documentsService } from "../../../utils/feathers";
import { saveAs } from "file-saver";

const useStyles = makeStyles((theme) => ({
  fab: {
    margin: theme.spacing(1),
    right: 10,
    bottom: 10,
    left: "auto",
    position: "fixed",
  },
}));

function Documents() {
  const classes = useStyles();
  const history = useHistory();
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({
    skip: 0,
    limit: 50,
    sort: { DocumentId: -1 },
    query: {},
  });

  const changeFilters = ({ skip, query, sort }) => {
    setFilters((prev) => ({ ...prev, skip, query, sort }));
  };

  const errorMessage = t("common.error");

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await documentsService.find({
          query: {
            $limit: filters.limit,
            $skip: filters.skip,
            $or: filters.query,
            $sort: filters.sort,
          },
        });

        setTotal(data.total);
        setRows(data.data);
      } catch (e) {
        enqueueSnackbar(errorMessage, { variant: "error" });
      }

      setIsLoading(false);
    }

    fetchData();
  }, [filters, errorMessage, enqueueSnackbar]);

  const onDelete = async (id) => {
    await documentsService.remove(id);
  };

  function handleDownload(row) {
    if (!row.DocumentURL) {
      return false;
    }

    const url = row.DocumentURL;
    const name = row.DocumentName;

    saveAs(url, name);
  }

  const title = t("documents.title");

  return (
    <div>
      <Helmet>
        <title>Attis - {title}</title>
      </Helmet>
      <Table
        title={title}
        path="documents"
        idColumn="DocumentId"
        tableColumns={[
          { title: t("documents.id"), name: "DocumentId" },
          {
            title: t("documents.policynumber"),
            name: "policy.PolicyNumber",
            getCellValue: (row) =>
              row.policy ? row.policy.PolicyNumber : undefined,
          },
          { title: t("documents.documentName"), name: "DocumentName" },
        ]}
        tableRows={rows}
        totalRows={total}
        changeFilters={changeFilters}
        onDelete={onDelete}
        customActions={[
          {
            icon: <DownloadIcon />,
            action: handleDownload,
            path: null,
          },
          {
            icon: <VisibilityIcon />,
            action: null,
            path: "/policies/edit/[[PolicyId]]",
          },
        ]}
        isLoading={isLoading}
      />
      <Fab
        color="primary"
        aria-label={t("common.new")}
        onClick={() => {
          history.push("/documents/new");
        }}
        className={classes.fab}
      >
        <AddIcon />
      </Fab>
    </div>
  );
}

export default Documents;
